import styled from "styled-components";

const StyledTableWrapper = styled.div`
  margin-bottom: 35px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  max-width: 100%;

  .filter-popup {
    z-index: 100;

    .ibis-MuiInputBase-input {
      border: 1px solid #efeff0;
      border-radius: ${props => props.theme.borderRadius};
      background-color: ${props => props.theme.colors.white};
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      outline: 0 !important;
      height: 24px;
      padding: ${props => props.theme.spacing(0.625, 1.875)};
      padding-right: ${props => props.theme.spacing(3.75)}px;
      font-size: ${props => props.theme.typography.h4.fontSize}px;
      font-weight: 400;
    }

    .ibis-MuiOutlinedInput-notchedOutline {
      display: none;
    }
  }

  .filter-wrapper,
  .order-by-wrapper,
  .order-by-icon-wrapper,
  .filter-icon-wrapper {
    user-select: none;
  }

  .filter-search-icon-wrapper {
    cursor: pointer;

    svg {
      width: 20px;
    }
  }

  .order-by-icon-wrapper {
    svg {
      width: 7px;
      height: 9px;
    }
  }

  th {
    .filter-popup {
      position: absolute;
      left: 0;

      &:not(.opened) {
        display: none;
      }
    }

    img {
      cursor: pointer;
    }

    &:hover {
      .order-by-wrapper {
        display: block !important;
        opacity: 0.5;
      }

      .filter-wrapper:not(.opened):not(.filtered-by) .filter-icon-wrapper {
        display: block !important;
        opacity: 0.5;
      }
    }

    .order-by-wrapper {
      position: absolute;
      top: 0;
      right: 20px;
      cursor: pointer;

      &.active {
        opacity: 1;
      }

      &:not(.active) {
        opacity: 0;
      }
    }
  }

  .filter-icon-wrapper {
    cursor: pointer;

    svg,
    img {
      pointer-events: none;
    }

    svg {
      width: 10px;
      height: 10px;
    }
  }

  tr th:nth-last-child(2) .filter-popup {
    left: -150px;
  }

  .filter-wrapper {
    position: absolute;
    top: 0;
    right: 0;

    &:not(.opened) {
      .filter-icon-wrapper {
        display: none;
      }
    }

    &.filtered-by {
      .filter-icon-wrapper {
        display: block !important;
        opacity: 1;
      }
    }
  }

  .cancel-filter-wrapper {
    cursor: pointer;
  }

  .filter-input,
  .filter-select-input {
    width: 300px;
  }

  td.numeric {
    text-align: right;
  }
`;

const StyledTr = styled.tr`
  height: 48px;

  &:hover {
    box-shadow: ${props => props.theme.shadow.primaryHover};
  }
`;

const StyledHeaderCell = styled.th`
  text-align: left;
`;

const StyledCell = styled.td<{ isClickable: boolean; isActionCell: boolean }>`
  cursor: ${props => (props.isClickable ? "pointer" : "")};
`;

const StyledTablePagination = styled.div`
  ${props => props.theme.breakpoints.down("xs")} {
    .ibis-MuiTablePagination-toolbar {
      padding: 0;
      min-height: auto;
      display: grid;
      justify-content: flex-end;

      .ibis-MuiTablePagination-caption {
        &:first-of-type {
          grid-area: 2/1;
          justify-self: flex-end;
        }
        &:last-of-type {
          grid-area: 1/1;
          justify-self: flex-end;
        }
      }
      .ibis-MuiTablePagination-input {
        grid-area: 2/2;
      }
      .ibis-MuiTablePagination-actions {
        grid-area: 1/2;
        margin: 0;
        justify-self: flex-end;
      }
    }
  }
`;

const StyledSearchBar = styled.div`
  width: 300px;
`;

const StyledSelectbox = styled.div`
  background-color: ${props => props.theme.colors.white};

  .ibis-MuiInputBase-root {
    display: flex;

    &:before,
    &:after {
      display: none;
    }

    .ibis-MuiSelect-nativeInput {
      top: 0;
    }

    .ibis-MuiSelect-select.ibis-MuiSelect-select {
      border: 1px solid #efeff0;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: ${props => props.theme.borderRadius};
      padding: ${props => props.theme.spacing(0.625, 4, 0.625, 1.5)};
      display: flex;
      align-items: center;
      line-height: 21px;
    }

    &.Mui-focused,
    &:focus {
      background-color: transparent;
    }

    .ibis-MuiSelect-select {
      &:focus {
        background-color: transparent;
      }
    }

    .ibis-MuiSvgIcon-root {
      right: 5px;
    }
  }
`;

export {
  StyledCell,
  StyledHeaderCell,
  StyledTable,
  StyledTableWrapper,
  StyledTr,
  StyledTablePagination,
  StyledSearchBar,
  StyledSelectbox,
};
